var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-list"},[_c('h6',{staticClass:"faq-list__title"},[_vm._v("Mijn aanvraag is ingediend, wat nu?")]),_c('FaqItem'),_c('FaqItem'),_c('FaqItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }